module.exports = __webpack_public_path__ + "static/media/Meditation Music Zone - Флейта музыка.9c64598c.mp3";